import { Box } from "@mui/material";

import ApplicationFunnelSection from "../ApplicationFunnelSection";
import ExecutiveKpiGrid from "../ExecutiveKpiGrid";
import BusinessHealthSummary from "../components/BusinessHealthSummary";
import ExecutiveOverviewKpiRow from "../components/ExecutiveOverviewKpiRow";
import BenchmarkComparisonSection from "../components/BenchmarkComparisonSection";
import ExecutiveBriefWidget from "../components/ExecutiveBriefWidget";
import HealthScoreWidget from "../components/HealthScoreWidget";
import MonthlyGrowthPanel from "../components/MonthlyGrowthPanel";

const ExecutiveOverviewTab = ({
  executiveKpis,
  currencyUnit,
  kpiLoading,
  kpiError,
  overview,
  growthAnalytics,
  analyticsLoading,
  funnelMeta,
  periodDays,
  setPeriodDays,
  alertsData,
  alertsLoading,
  alertsError,
  healthScoreLoading,
  healthScoreError,
  healthScoreData,
  briefLoading,
  briefError,
  briefData,
  dashboardAccess,
  benchmarkLoading,
  benchmarkError,
  benchmarkData,
  benchmarkDimension,
  setBenchmarkDimension,
  funnelLoading,
  funnelError,
  funnelStages,
  dashboardFilters,
  loadExecutiveKpis,
  loadAlerts,
  loadHealthScore,
  loadExecutiveBrief,
  loadBenchmarkComparison,
  loadFunnel,
}) => (
  <Box>
    <HealthScoreWidget
      loading={healthScoreLoading}
      error={healthScoreError}
      data={healthScoreData}
      onRetry={() => loadHealthScore(dashboardFilters)}
    />

    <ExecutiveBriefWidget
      loading={briefLoading}
      error={briefError}
      data={briefData}
      onRetry={() => loadExecutiveBrief(dashboardFilters)}
      dashboardFilters={dashboardFilters}
      canExport={dashboardAccess?.canExportReports !== false}
    />

    <BenchmarkComparisonSection
      loading={benchmarkLoading}
      error={benchmarkError}
      data={benchmarkData}
      dimensionType={benchmarkDimension}
      onDimensionChange={(dim) => {
        setBenchmarkDimension(dim);
        loadBenchmarkComparison(dashboardFilters, dim);
      }}
      onRetry={() => loadBenchmarkComparison(dashboardFilters, benchmarkDimension)}
    />

    <ExecutiveOverviewKpiRow
      executiveKpis={executiveKpis}
      currencyUnit={currencyUnit}
      overview={overview}
      growthAnalytics={growthAnalytics}
      funnelMeta={funnelMeta}
      loading={kpiLoading || analyticsLoading}
      error={kpiError}
      onRetry={() => loadExecutiveKpis(dashboardFilters)}
    />

    <Box sx={{ mb: 2 }}>
      <BusinessHealthSummary
        alertsData={alertsData}
        loading={alertsLoading}
        error={alertsError}
        onRetry={() => loadAlerts(dashboardFilters)}
      />
    </Box>

    <ApplicationFunnelSection
      loading={funnelLoading}
      error={funnelError}
      stages={funnelStages}
      cohortSize={funnelMeta.cohortSize}
      excludedCancelledCount={funnelMeta.excludedCancelledCount}
      onRetry={() => loadFunnel(dashboardFilters)}
    />

    <MonthlyGrowthPanel
      growthAnalytics={growthAnalytics}
      analyticsLoading={analyticsLoading}
      periodDays={periodDays}
      onPeriodChange={setPeriodDays}
    />

    <ExecutiveKpiGrid
      kpis={executiveKpis}
      currencyUnit={currencyUnit}
      loading={kpiLoading}
      error={kpiError}
      onRetry={() => loadExecutiveKpis(dashboardFilters)}
    />
  </Box>
);

export default ExecutiveOverviewTab;
